import { useMemo } from 'react';

import { mapGetApiUserResponsesToDomain } from '@/domain/apiUsers/mappers';
import type { UseGetApiUsersResult } from '@/domain/apiUsers/types';
import { useClientController_getApiUsers } from '@/services/hooks';

export const useGetApiUsers = (clientId: number): UseGetApiUsersResult => {
    const apiUsersQuery = useClientController_getApiUsers(clientId);

    const apiUsers = useMemo(
        () => mapGetApiUserResponsesToDomain(apiUsersQuery.data?.data ?? []),
        [apiUsersQuery.data?.data]
    );

    return {
        ...apiUsersQuery,
        isLoading: apiUsersQuery.isPending,
        data: apiUsers,
    };
};
